export default "__VITE_ASSET__BAMg0TQF__"